import { Box, Button } from "@mui/material";
import { t } from "i18next";
import React, { ReactNode, useState } from "react";
import CreateUnitForm from "./CreateGroupForm";
import { NavigationLevel } from "@nendaTypes/NendaTypes";

interface CreateGroupProps {
  createFor: NavigationLevel.COMPANY | NavigationLevel.PREMISE;
  parentId: string;
}

const CreateGroup: React.FC<CreateGroupProps> = ({
  createFor,
  parentId,
}): ReactNode => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const toggleOpen = (): void => {
    setIsFormOpen(!isFormOpen);
  };

  const handleCreateButtonClick = (): void => {
    toggleOpen();
  };

  const handleFormClose = (): void => {
    toggleOpen();
  };

  return (
    <Box>
      {!isFormOpen && (
        <Button
          variant="contained"
          color="primary"
          onClick={handleCreateButtonClick}
        >
          {t("customerportal.pages.groups.create_group")}
        </Button>
      )}
      {isFormOpen && (
        <CreateUnitForm
          isOpen={isFormOpen}
          onClose={handleFormClose}
          createFor={createFor}
          parentId={parentId}
        />
      )}
    </Box>
  );
};

export default CreateGroup;
